// src/data/categories.js
const categories = [
  {
      "name": "Tecnologia",
      "subcategories": [
          "Todo",
          "Accesorios",
          "Audifonos",
          "Smart Home",
          "SmartHome"
      ]
  },
  {
      "name": "Hogar",
      "subcategories": [
          "Todo",
          "Decoracion",
          "Iluminacion",
          "Vasos Infantiles"
      ]
  },
  {
      "name": "Belleza",
      "subcategories": [
          "Todo",
          "Maquilaje"
      ]
  },
  {
      "name": "Mascotas",
      "subcategories": [
          "Todo",
          "Accesorios",
          "Moda"
      ]
  },
  {
      "name": "Niños",
      "subcategories": [
          "Todo",
          "Juguetes Tecnologicos",
          "Manualidades",
          "Seguridad"
      ]
  },
  {
      "name": "Moda",
      "subcategories": [
          "Todo",
          "Ropa Bebe Niñas",
          "Ropa Bebe Niños"
      ]
  }
];
  
  export default categories;
  